// extracted by mini-css-extract-plugin
export default {"wrapper":"lLQeS","container":"ocfby","title":"aQf6u","text":"NMQqT","button":"wBLyz","nuans":"JNqwf"};